// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"Eyecatcher-module--bannerContainer--0e7483","banner":"Eyecatcher-module--banner--deb523","badgePosition":"Eyecatcher-module--badgePosition--3324a1"};